import * as React from "react";
import styled, { css } from "styled-components";
import { MediaQueries } from "src/constants";

const BreakpointEl: any = styled.div`
  display: block;

  ${(props: Props) =>
    props.medium &&
    css`
      ${MediaQueries.screen.medium.minWidth} {
        display: ${props.up ? "block" : "none"};
      }

      ${MediaQueries.screen.medium.maxWidth} {
        display: ${props.up ? "none" : "block"};
      }
    `}

  ${(props: Props) =>
    props.large &&
    css`
      ${MediaQueries.screen.large.minWidth} {
        display: ${props.up ? "block" : "none"};
      }

      ${MediaQueries.screen.large.maxWidth} {
        display: ${props.up ? "none" : "block"};
      }
    `}
`;

type Props = {
  medium?: boolean;
  large?: boolean;
  up?: boolean;
  down?: boolean;
} & React.HTMLProps<HTMLDivElement>;

export const Breakpoint: React.FC<Props> = ({ children, ...props }: Props) => {
  return <BreakpointEl {...props}>{children}</BreakpointEl>;
};
